import { render } from "./ApointmentTestsComponent.vue?vue&type=template&id=6cc7bad7&scoped=true"
import script from "./ApointmentTestsComponent.vue?vue&type=script&lang=js"
export * from "./ApointmentTestsComponent.vue?vue&type=script&lang=js"

import "./ApointmentTestsComponent.vue?vue&type=style&index=0&id=6cc7bad7&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc7bad7"]])

export default __exports__